const getMenuItems = (t, permissions) => [
  {
    key: "home",
    url: "/home",
    // icon: "icon icon-home",
    title: t("home"),
    style: { color: "white" },
    children: [
      {
        key: "home-act",
        url: "/home-act",
        icon: "icon icon-revenue-new",
        title: t("accountTransactionsSubMenu"),
        module: 1,
      },
      {
        key: "home-pos",
        url: "/home-pos",
        icon: "icon icon-pricing-table",
        title: t("posReport"),
        module: 5,
      },
      {
        key: "home-dbs",
        url: "/home-dbs",
        icon: "icon icon-family",
        title: t("directDebitSystem"),
        module: 3,
      },
      {
        key: "home-b2b",
        url: "/home-b2b",
        icon: "icon icon-profile",
        title: t("b2bHomepage"),
        module: 8,
      },
      {
        key: "home-subscriberFirm",
        url: "/home-subscriberFirm",
        icon: "icon icon-all-contacts",
        title: t("apartmentSite"),
        module: 9,
      },
    ],
  },
  {
    key: "accountprocess",
    // icon: "icon icon-card",
    title: t("accountTransactions"),
    module: 1,
    children: [
      {
        key: "bank-list",
        url: "/bank-list",
        icon: "icon icon-all-contacts",
        title: t("bankBalances"),
      },
      {
        key: "bank-accounts",
        url: "/bank-accounts",
        icon: "icon icon-cards-list-view",
        title: t("accountBalances"),
      },
      {
        key: "account-transaction",
        url: "/account-transaction",
        icon: "icon icon-select",
        title: t("accountTransactionsSubMenu"),
      },
      {
        key: "consolidate-transacitons",
        icon: "icon icon-all-contacts",
        title: t("consolidatedBalance"),
        isRender: permissions.isGroupUser,
        children: [
          {
            key: "consolidated-bank",
            url: "/consolidated/bank",
            icon: "icon icon-all-contacts",
            title: t("bank"),
          },
          {
            key: "consolidated-transactions",
            url: "/consolidated/account-transaction",
            icon: "icon icon-select",
            title: t("accountTransactionsSubMenu"),
          },
        ],
      },
    ],
  },
  {
    key: "posOperations",
    // icon: "icon icon-revenue-new",
    title: t("posReport"),
    module: 5,
    children: [
      {
        key: "pos-transaction",
        url: "/pos-transaction",
        icon: "icon icon-all-contacts",
        title: t("posTransactions"),
      },
      {
        key: "pos-reports",
        url: "/pos-reports",
        icon: "icon icon-all-contacts",
        title: t("summaryGraphics"),
        isRender: permissions.isShowPosSummaryGraphic,
      },
      {
        key: "value-report",
        url: "/value-report",
        icon: "icon icon-all-contacts",
        title: t("valueReport"),
      },
      {
        key: "commission-report",
        url: "/commission-report",
        icon: "icon icon-all-contacts",
        title: t("commissionReport"),
      },
      {
        key: "pos-volume-report",
        url: "/pos-volume-report",
        icon: "icon icon-all-contacts",
        title: t("posTransactionVolumeReport"),
      },
      {
        key: "pos-early-unblock-report",
        url: "/pos-early-unblock",
        icon: "icon icon-all-contacts",
        title: t("earlyUnblockReport"),
        isRender: permissions.isAllowPosEarlyUnblock,
      },
      {
        key: "commission-definition",
        url: "/commission-definition",
        icon: "icon icon-feedback",
        title: t("commissionDefinition"),
      },
      {
        key: "pos-memberworkplace-terminal-list",
        url: "/pos-memberworkplace-terminal-list",
        icon: "icon icon-all-contacts",
        title: t("memberWorkplaceTerminalList"),
      },
    ],
  },
  {
    key: "tos",
    // icon: "icon icon-revenue-new",
    title: t("tos"),
    module: 2,
    children: [
      {
        key: "tos-payment",
        url: "/tos-payment",
        icon: "icon icon-ckeditor",
        title: t("paymentList"),
      },
      {
        key: "tos-order",
        url: "/tos-order",
        icon: "icon icon-editor",
        title: t("orderList"),
      },
      {
        key: "tos-sent-order",
        url: "/tos-sent-order",
        icon: "icon icon-editor",
        title: t("sentOrders"),
      },
      {
        key: "tos-sent-payment",
        url: "/tos-sent-payment",
        icon: "icon icon-editor",
        title: t("sentPayments"),
      },
    ],
  },
  {
    key: "dbs",
    // icon: "icon icon-revenue-new",
    title: t("dbs"),
    module: 3,
    children: [
      {
        key: "dbs-dealer",
        url: "/dbs-dealer",
        icon: "icon icon-team",
        title: t("dealerInformation"),
      },
      {
        key: "dbs-invoice",
        url: "/dbs-invoice",
        icon: "icon icon-editor",
        title: t("invoiceList"),
      },
      {
        key: "dbs-sent-invoice",
        url: "/dbs-sent-invoice",
        icon: "icon icon-sent",
        title: t("sentInvoices"),
      },
      {
        key: "dbs-report",
        icon: "icon icon-data-display",
        title: t("reports"),
        children: [
          {
            key: "dbs-report/bank-limit-report",
            url: "/dbs-report/bank-limit-report",
            icon: "icon icon-chart-radial",
            title: t("bankBasedLimitReport"),
          },
          {
            key: "dbs-report/bank-volume-report",
            url: "/dbs-report/bank-volume-report",
            icon: "icon icon-chart-composed",
            title: t("bankBasedVolumeReport"),
          },
          {
            key: "dbs-report/firm-status-report",
            url: "/dbs-report/firm-status-report",
            icon: "icon icon-profile",
            title: t("dbsFirmStatusReport"),
          },
          {
            key: "dbs-report/value-report",
            url: "/dbs-report/value-report",
            icon: "icon icon-all-contacts",
            title: t("futureReceivablesReport"),
          },
        ],
      },
    ],
  },
  {
    key: "subscriberFirm",
    // icon: "icon icon-card",
    title: t("asy"),
    module: 9,
    children: [
      {
        key: "subscriberfirm-list",
        url: "/subscriberfirm-list",
        icon: "icon icon-all-contacts",
        title: t("apartmentList"),
      },
      {
        key: "subscriberfirm-status-report",
        url: "/subscriberfirm-status-report",
        icon: "icon icon-profile",
        title: t("apartmentStatuses"),
      },
      {
        key: "subscriberfirm-pos-collection-transaction",
        url: "/subscriberfirm-pos-collection-transaction",
        icon: "icon icon-timepicker",
        title: t("posSubscriptionPayments"),
      },
    ],
  },
  {
    key: "reports",
    // icon: "icon icon-amchart",
    title: t("reports"),
    module: 12,
    children: [
      {
        key: "firm-status-report",
        url: "/firm-status-report",
        icon: "icon icon-company",
        title: t("firmStatusReport"),
      },
      {
        key: "chart-reports",
        url: "/chart-reports",
        icon: "icon icon-company",
        title: t("monthlyChart"),
      },
      {
        key: "bank-based-transaction",
        url: "/bank-based-transaction",
        icon: "icon icon-company",
        title: t("bankBasedTransaction"),
      },
      {
        key: "monthly-firm-status-report",
        url: "/monthly-firm-status-report",
        icon: "icon icon-company",
        title: t("dateBasedStatus"),
      },
      {
        key: "day-reports",
        url: "/day-reports",
        icon: "icon icon-company",
        title: t("endOfDayReport"),
      },
      {
        key: "balance-reports",
        url: "/balance-reports",
        icon: "icon icon-company",
        title: t("balanceReport"),
      },
      {
        key: "risk-analysis",
        url: "/risk-analysis",
        icon: "icon icon-chart-line",
        title: t("riskAnalysisReport"),
        module: 14,
      },
      {
        key: "credit-report",
        url: "/credit-report",
        icon: "icon icon-chart-line",
        title: t("creditReport"),
        isRender: permissions.isUseCreditReport,
      },
      {
        key: "cash-flow-report",
        url: "/cash-flow-report",
        icon: "icon icon-company",
        title: t("cashFlowReport"),
      },
    ],
  },
  {
    key: "firms",
    // icon: "icon icon-company",
    title: t("firmOperations"),
    children: [
      {
        key: "firm-list",
        url: "/firm-list",
        icon: "icon icon-all-contacts",
        title: t("firmList"),
      },
      {
        key: "firm-account-list",
        url: "/firm-account-list",
        icon: "icon icon-anchor",
        title: t("firmAccounts"),
      },
      {
        key: "firm-transaction-list",
        url: "/firm-transaction-list",
        icon: "icon icon-anchor",
        title: t("firmAccountStatement"),
        isRender: permissions.isFirmTransaction,
      },
    ],
  },
  {
    key: "paymentManagement",
    // icon: "icon icon-company",
    title: t("cashManagement"),
    children: [
      {
        key: "monthlyPlans",
        icon: "icon icon-company",
        title: t("incomeExpensePlanning"),
        url: "/monthly-plan-list",
      },
      {
        key: "manual-account-transaction",
        url: "/manual-account-transaction",
        icon: "icon icon-data-entry",
        title: t("cashOperations"),
      },
    ],
  },
  {
    key: "erp",
    title: t("erp"),
    module: 7,
    children: [
      {
        key: "erp-incoming-transaction",
        url: "/erp-incoming-transaction",
        icon: "icon icon-chart-line",
        title: t("incomingTransactions"),
      },
      {
        key: "erp-outgoing-transaction",
        url: "/erp-outgoing-transaction",
        icon: "icon icon-chart-area-new",
        title: t("outgoingTransactions"),
      },
      {
        key: "erp-pos-transaction",
        url: "/erp-pos-transaction",
        icon: "icon icon-chart-line",
        title: t("posCollectionTransfer"),
      },
      {
        key: "erp-creditcard-plan-transaction",
        url: "/erp-creditcard-plan-transaction",
        icon: "icon icon-chart-area-new",
        title: t("checkBillCreditCardCashTransfer"),
      },
      {
        key: "erp-pos-report-transaction",
        url: "/erp-pos-report-transaction",
        icon: "icon icon-chart-line",
        title: t("posReportTransfer"),
      },
      {
        key: "erp-dbs-invoice",
        url: "/erp-dbs-invoice",
        icon: "icon icon-chart-line",
        title: t("dbsInvoiceTransfer"),
      },
      {
        key: "erp-report",
        icon: "icon icon-pricing-table",
        title: t("erpReport"),
        children: [
          {
            key: "erp-firm-report",
            url: "/erp-firm-report",
            icon: "icon icon-all-contacts",
            title: t("firmTracking"),
          },
          {
            key: "erp-stock-report",
            url: "/erp-stock-report",
            icon: "icon icon-all-contacts",
            title: t("stockStatus"),
          },
        ],
      },
      {
        key: "erp-activity-list",
        url: "/erp-activity-list",
        icon: "icon icon-data-entry",
        title: t("dataUpload"),
      },
      {
        key: "account-transaction-excel",
        url: "/account-transaction-excel",
        icon: "icon icon-select",
        title: t("accountTransactionsExcel"),
      },
    ],
  },
  {
    key: "b2b",
    title: t("b2b"),
    module: 8,
    children: [
      {
        key: "pos-collection-transaction",
        url: "/pos-collection-transaction",
        icon: "icon icon-timepicker",
        title: t("collectionHistory"),
      },
      {
        key: "pos-collection",
        url: "/pos-collection",
        icon: "icon icon-litcoin",
        title: t("posCollection"),
      },

      {
        key: "payment-request",
        url: "/payment-request",
        icon: "icon icon-contacts",
        title: t("createPaymentLink"),
      },
      {
        key: "payment-list",
        url: "/payment-list",
        icon: "icon icon-all-contacts",
        title: t("linkPaymentTracking"),
      },
      {
        key: "collection-commission-definition",
        url: "/collection-commission-definition",
        icon: "icon icon-feedback",
        title: t("bankInstallmentDefinitions"),
      },
      {
        key: "firm-panel",
        url: "/firm-panel",
        icon: "icon icon-company",
        title: t("b2bCompanyDefinition"),
      },
    ],
  },
  {
    key: "setting",
    // icon: "icon icon-setting",
    title: t("settings"),
    isRender: permissions.isAdmin,
    children: [
      {
        key: "group-list",
        url: "/group-list",
        icon: "icon icon-company",
        title: t("groupManagement"),
        isRender: permissions.isGroupAdmin,
      },
      {
        key: "transaction-bank-info",
        url: "/transaction-bank-info",
        icon: "icon icon-all-contacts",
        title: t("bankAccess"),
      },
      // {
      //   key: "currency-live",
      //   url: "",
      //   icon: "icon icon-cards-list-view",
      //   title: "Döviz Kuru",
      // },
      {
        key: "tenant-parameter",
        url: "/tenant-parameter",
        icon: "icon icon-setting",
        title: t("companySettings"),
      },
      // {
      //   key: "password-access",
      //   url: "",
      //   icon: "icon icon-cards-list-view",
      //   title: "Sms Onayı",
      // },
      {
        key: "notifications",
        url: "/notifications",
        icon: "icon icon-cards-list-view",
        title: t("notification"),
      },
      {
        key: "user-list",
        url: "/user-list",
        icon: "icon icon-all-contacts",
        title: t("userList"),
      },
      {
        key: "types",
        // icon: "icon icon-setting",
        title: t("transactionTypes"),
        children: [
          {
            key: "firm-class-list",
            url: "/firm-class-list",
            icon: "icon icon-menu-unfold",
            title: t("firmClasses"),
          },
          {
            key: "monthly-plan-type-list",
            url: "/monthly-plan-type-list",
            icon: "icon icon-home",
            title: t("incomeExpenseTypes"),
          },
          {
            key: "manual-account-transaction-type",
            url: "/manual-account-transaction-type",
            icon: "icon icon-data-entry",
            title: t("cashTransactionType"),
          },
          {
            key: "transaction-project-type",
            url: "/transaction-project-type",
            icon: "icon icon-all-contacts",
            title: t("transferParameters"),
          },
        ],
      },
      {
        key: "accountTransactionRules",
        url: "/account-transaction-rule",
        icon: "icon icon-cards-list-view",
        title: t("ruleList"),
      },
      {
        key: "tenant-screen-settings",
        url: "/tenant-screen-settings",
        icon: "icon icon-setting",
        title: t("screenSettings"),
      },
    ],
  },
];

export default getMenuItems;
